import { Grid, Button, Typography } from "@material-ui/core";

const Error = () => <Grid container justify="center" alignItems="center" direction="column">
    <Typography variant="h5" style={{margin: "2em"}}>Er is een fout opgetreden.</Typography>
    <Button onClick={() => window.location.reload()} variant="outlined">Klik om opnieuw te laden</Button>
</Grid>

export default Error;